/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PageIDEnums {
    HOME = 1,
    USER_PERMISSIONS = 2,
    USER_PREFERENCES = 3,
    INSURED = 4,
    ADMIN_TOOLS = 5,
    AGENCY = 6,
    UNDERWRITING = 7,
    BILLING = 8,
    SANDBOX = 9,
    STYLE_GUIDE = 10,
    CLAIMS = 11,
    DEFAULT = 12,
}
